
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#pending-payment-exclamation-mark-icon_svg__clip0_7398_114783)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.414 8L8 1.414 14.586 8 8 14.586 1.414 8zM7.47.53a.75.75 0 011.06 0l6.94 6.94a.75.75 0 010 1.06l-6.94 6.94a.75.75 0 01-1.06 0L.53 8.53a.75.75 0 010-1.06L7.47.53zM7.625 4c-.219 0-.375.187-.375.406l.219 5.25c0 .188.187.344.375.344h.28c.188 0 .376-.156.376-.344l.219-5.25c0-.219-.157-.406-.375-.406h-.72zM8 10.625c-.5 0-.875.406-.875.875 0 .5.375.875.875.875a.873.873 0 00.875-.875.894.894 0 00-.875-.875z","fill":"#F2514A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"pending-payment-exclamation-mark-icon_svg__clip0_7398_114783"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    